module.exports = __webpack_public_path__ + "resources/img/img-zenius-apm-02-m-en.1a139317017dee19ea4b00fac9f70199.png";